import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const adminGetOverViewDetails = catchAsync(async (params?: object) => {
  const { data } = await axiosInstance.get(`admin/overview`, {
    params,
  });
  return data;
});

export const getLocationsAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/locations`, {
    params,
  });
  return data;
});
export const getLocationDetailsAdmin = catchAsync(async (id: number) => {
  const { data } = await axiosInstance.get(`admin/locations/${id}`);
  return data;
});
export const getClientsAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/clients`, {
    params,
  });
  return data;
});
export const getTimeOffAdmin = catchAsync(
  async (salonId: any, TeamMemberId: any, params: any) => {
    const { data } = await axiosInstance.get(
      `admin/${salonId}/team-member/${TeamMemberId}/time-offs`,
      {
        params,
      }
    );
    return data;
  }
);
export const DeleteTimeOffAdmin = catchAsync(async (body: any) => {
  const data = await axiosInstance.delete(
    `admin/${body?.salonId}/team-member/${body?.teamMemberId}/time-offs/${body?.id}`
  );
  return data;
});
export const getAppointmentsAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/appointments`, {
    params,
  });
  return data;
});
export const getPackagesAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/packages`, {
    params,
  });
  return data;
});
export const getGiftCardsAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/gift-cards`, {
    params,
  });
  return data;
});
export const getProductsAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/products`, {
    params,
  });
  return data;
});
export const getServicesAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/services`, {
    params,
  });
  return data;
});
export const getServicesWithCategoriesAdmin = catchAsync(
  async (params: any) => {
    const { data } = await axiosInstance.get(`admin/service-categories`, {
      params,
    });
    return data;
  }
);
export const getMembershipsAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/memberships`, {
    params,
  });
  return data;
});
export const getTeamMembersAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/team-members`, {
    params,
  });
  return data;
});
export const UpdateOpeningHoursAdmin = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`admin/${body?.id}/opening-hours`, {
    opening_hours: body?.opening_hours,
  });
  return data;
});
export const AddBlogAdmin = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`admin/blogs`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
});
export const UpdateBlogAdmin = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`admin/blogs/${body?.id}`, body.data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
});

export const DeleteBlogAdmin = catchAsync(async (id: any) => {
  const data = await axiosInstance.delete(`admin/blogs/${id}`);
  return data;
});
export const ListBlogsAdmin = catchAsync(async (params: any) => {
  const { data } = await axiosInstance.get(`admin/blogs`, {
    params,
  });
  return data;
});
export const ShowBlogsAdmin = catchAsync(async (id: any,xTranslate = false) => {
  const { data } = await axiosInstance.get(`admin/blogs/${id}`,{
    headers: {  "x-translations": xTranslate,},
  });
  return data;
});
export const AddCateBlogAdmin = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`admin/blog-categories`, body);
  return data;
});
export const DeleteCateBlogAdmin = catchAsync(async (id: any) => {
  const data = await axiosInstance.delete(
    `admin/blog-categories/${id}`
  );
  return data;
});
export const ShowCateBlogAdmin = catchAsync(async (id: any,xTranslations:boolean) => {
  const { data } = await axiosInstance.get(`admin/blog-categories/${id}`, {
    headers: {
      "x-translations": xTranslations,
    },});
  return data;
});
export const ListCateBlogAdmin = catchAsync(async (params: any, xTranslations = false) => {
  const { data } = await axiosInstance.get('admin/blog-categories', {
      params,
      headers: {
        'x-translations': xTranslations
      }
  });
      return data;

});
export const UpdateCateBlogAdmin = catchAsync(async (body: any,) => {
  const data = await axiosInstance.put(`admin/blog-categories/${body?.id}`, body);
  return data;
});
export const UpdateStatusSalonAdmin = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(
    `admin/change-status-location/${body?.id}`,
    {
      status: body?.status,
    }
  );
  return data;
});
export const UpdateBulkStatus = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`admin/locations/bulk/status`, body);
  return data;
});
export const deleteBulkSalonAdmin = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`admin/locations`, body);
  return data;
});
export const deleteSalonAdmin = catchAsync(async (id: number) => {
  const data = await axiosInstance.delete(`admin/locations/${id}`);
  return data;
});

export const getAppointmentDetails = catchAsync(
  async (id: number, params: any) => {
    const { data } = await axiosInstance.get(`admin/appointments/${id}`, {
      params,
    });
    return data;
  }
);

export const adminUpdateAppointment = catchAsync(
  (locationId: number, appointmentId: number, body: {}) => {
    return axiosInstance.put(
      `admin/${locationId}/appointments/${appointmentId}`,
      body
    );
  }
);

export const adminUpdateLocationOnlineProfile = catchAsync(
  (locationId: number, body: any) => {
    return axiosInstance.post(`admin/${locationId}/online-profile`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
);
export const AdminListParentWithServices = catchAsync(
  async (params: object) => {
    const { data } = await axiosInstance.get("admin/all-services", { params });
    return data;
  }
);

export const adminGetPackagesWithCategories = catchAsync(
  async (locationId: number) => {
    const { data } = await axiosInstance.get(
      `admin/${locationId}/categories-packages`
    );
    return data;
  }
);

export const adminGetAvailableTeamMembers = catchAsync(async (body: any) => {
  const { data } = await axiosInstance.post(
    `admin/${body?.locationId}/appointments/available-team-members`,
    body
  );
  return data;
});

export const adminGetCancelReasons = catchAsync((salonId: number) => {
  return axiosInstance.get(`admin/${salonId}/cancellation-reasons`);
});

export const adminCancelAppointment = catchAsync(
  (locationId: number, appointmentId: number, reason: string | null) => {
    return axiosInstance.post(
      `admin/${locationId}/appointments/${appointmentId}/cancel`,
      { cancellation_reason_id: reason }
    );
  }
);
export const adminGetMemberships = catchAsync((locationId: number) => {
  return axiosInstance.get(`admin/${locationId}/memberships`);
});

export const adminGetPricingPlans = catchAsync((locationId: number) => {
  return axiosInstance.get(`admin/subscription-plans`);
});

export const adminAddTeamMember = catchAsync(async (body: object) => {
  const data = await axiosInstance.post(`admin/team-members`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
});
export const AddNewLocation = catchAsync((body: any) => {
  return axiosInstance.post(`admin/locations`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
});

export const adminShowTeamMember = catchAsync(
  async (teamMemberId: number, xTranslations?: boolean) => {
    const { data } = await axiosInstance.get(
      `admin/team-members/${teamMemberId}`,
      {
        headers: {
          "x-translations": xTranslations,
        },
      }
    );
    return data;
  }
);
export const adminEditTeamMember = catchAsync(
  async (teamMemberId: number, body: object) => {
    const { data } = await axiosInstance.post(
      `admin/team-members/${teamMemberId}`,
      body,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return data;
  }
);
export const adminDeleteTeamMember = catchAsync(
  async (teamMemberId: number) => {
    const { data } = await axiosInstance.delete(
      `admin/team-members/${teamMemberId}`
    );
    return data;
  }
);
export const getWorkingsHourTeamMember = catchAsync(
  (locationId: any, TeamMemberId: any, params: any) => {
    return axiosInstance.get(
      `admin/${locationId}/team-members/${TeamMemberId}/working-hours`,
      {
        params,
      }
    );
  }
);
export const getClosePeriodSalonTeamMember = catchAsync((salonId: any) => {
  return axiosInstance.get(`admin/${salonId}/closed-periods`);
});
// client apis

export const adminShowClient = catchAsync(async (clientId: number) => {
  const { data } = await axiosInstance.get(`admin/clients/${clientId}`);
  return data;
});
export const adminAddClient = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`admin/clients`, body);
  return data;
});

export const adminUpdateClient = catchAsync(
  async (clientId: number, body: any) => {
    const data = await axiosInstance.put(`admin/clients/${clientId}`, body);
    return data;
  }
);

export const adminDeleteClient = catchAsync(async (clientId: number) => {
  const data = await axiosInstance.delete(`admin/clients/${clientId}`);
  return data;
});

// Appointment
export const adminDeleteAppontment = catchAsync(async (body: any) => {
  const data = await axiosInstance.delete(`admin/appointments`, { data: body });
  return data;
});
// catalog bulk delete
export const adminDeleteServices = catchAsync(async (body: any) => {
  const data = await axiosInstance.delete(`admin/services`, { data: body });
  return data;
});
export const adminDeleteProduct = catchAsync(async (body: any) => {
  const data = await axiosInstance.delete(`admin/products`, { data: body });
  return data;
});
export const adminDeleteMembership = catchAsync(async (body: any) => {
  const data = await axiosInstance.delete(`admin/memberships`, { data: body });
  return data;
});
export const adminDeletePackage = catchAsync(async (body: any) => {
  const data = await axiosInstance.delete(`admin/packages`, { data: body });
  return data;
});
export const adminDeleteGiftCard = catchAsync(async (body: any) => {
  const data = await axiosInstance.delete(`admin/gift-cards`, { data: body });
  return data;
});

export const adminDeleteWorkingHours = catchAsync(async (id: number) => {
  const data = await axiosInstance.delete(`admin/working-shift/${id}`);
  return data;
});

export const adminUpdateWorkingHours = catchAsync(
  async (
    locationId: number,
    teamMemberId: number,
    workingHoursId: number,
    body: any
  ) => {
    const data = await axiosInstance.put(
      `admin/${locationId}/team-members/${teamMemberId}/working-hours/${workingHoursId}`,
      body
    );
    return data;
  }
);

export const adminAddWorkingHours = catchAsync(
  async (locationId: number, teamMemberId: number, body: any) => {
    const data = await axiosInstance.post(
      `admin/${locationId}/team-members/${teamMemberId}/working-hours`,
      body
    );
    return data;
  }
);

export const adminAdditionalShifts = catchAsync(
  async (locationId: number, teamMemberId: number, body: any) => {
    const data = await axiosInstance.post(
      `admin/${locationId}/team-members/${teamMemberId}/working-shifts`,
      body
    );
    return data;
  }
);

export const adminGetTimeOffTypes = catchAsync(async (salonId: number) => {
  const data = await axiosInstance.get(`admin/${salonId}/time-off-types`);
  return data;
});
export const adminAddBreakToShift = catchAsync(
  async (
    locationId: number,
    teamMemberId: number,
    shiftId: number,
    body: any
  ) => {
    const data = await axiosInstance.post(
      `admin/${locationId}/team-members/${teamMemberId}/${shiftId}/break`,
      body
    );
    return data;
  }
);

export const adminDeleteAdditionalShift = catchAsync(
  async ({
    locationId,
    teamMemberId,
    deletedItemId,
  }: {
    locationId: number;
    teamMemberId: number;
    deletedItemId: number;
  }) => {
    const data = await axiosInstance.delete(
      `admin/${locationId}/team-members/${teamMemberId}/working-shifts/${deletedItemId}`
    );
    return data;
  }
);

export const adminDeleteBreak = catchAsync(
  async ({
    locationId,
    teamMemberId,
    deletedItemId,
  }: {
    locationId: number;
    teamMemberId: number;
    deletedItemId: number;
  }) => {
    const data = await axiosInstance.delete(
      `admin/${locationId}/team-members/${teamMemberId}/break/${deletedItemId}`
    );
    return data;
  }
);
export const adminGetTeamMemberVacations = catchAsync(
  async (salonId: number, teamMemberId: number) => {
    const data = await axiosInstance.get(
      `admin/${salonId}/team-member/${teamMemberId}/time-offs`
    );
    return data;
  }
);

export const adminAddTeamMemberVacation = catchAsync(
  async (salonId: number, teamMemberId: number, body: any) => {
    const data = await axiosInstance.post(
      `admin/${salonId}/team-member/${teamMemberId}/time-offs`,
      body
    );
    return data;
  }
);

export const adminEditTeamMemberVacation = catchAsync(
  async (
    salonId: number,
    teamMemberId: number,
    vacationIdd: number,
    body: any
  ) => {
    const data = await axiosInstance.put(
      `admin/${salonId}/team-member/${teamMemberId}/time-offs/${vacationIdd}`,
      body
    );
    return data;
  }
);

export const adminDeleteTeamMemberVacation = catchAsync(
  async (salonId: number, teamMemberId: number, vacationIdd: number) => {
    const data = await axiosInstance.delete(
      `admin/${salonId}/team-member/${teamMemberId}/time-offs/${vacationIdd}`
    );
    return data;
  }
);
export const adminDeleteBulkTeamMembers = catchAsync(async (ids: number[]) => {
  const data = await axiosInstance.delete(`admin/team-members`, {
    data: ids,
  });
  return data;
});
export const getContactUsRequests = catchAsync(async (params?: object) => {
  const { data } = await axiosInstance.get(`admin/contact-us`, {
    params,
  });
  return data;
});
// https://tips-api.lookfindrdev.com
export const getTransactions = catchAsync(async (params?: object) => {
  const { data } = await axiosInstance.get(`admin/transactions`, {
    params,
  });
  return data;
});

export const adminChangeContactUsRequestStatus = catchAsync(
  async (id: string, body: any) => {
    const { data } = await axiosInstance.put(`admin/contact-us/${id}`, body);
    return data;
  }
);

export const transactionChangeStatus = catchAsync(
  async (id: string, body: any) => {
    const { data } = await axiosInstance.put(`admin/transactions/${id}/transferred`, body);
    return data;
  }
);

export const adminGetSalonPaymentMethods = catchAsync(
  async (salonId: number) => {
    const { data } = await axiosInstance.get(
      `admin/${salonId}/payment-methods`
    );
    return data;
  }
);
